import React, { useState, useEffect, useRef, useContext } from 'react'
import classNames from 'classnames'
import {
    Spacer,
    Field,
    Button,
    Radio,
    Label,
    Divider,
    Checkbox,
    Card,
    Icon,
    Row,
    Col,
    Collapse
} from '@cleartrip/bento'
import Modal from 'lib/Modal'
import ModalHeader from '../UserProfileModalHeader'
import Dropdown from 'components/Dropdown'
import langTranslate from 'locale'
import OfflineToast from 'components/GlobalNav/UserProfile/offlineToast'
import OtpBox from './otpBox'
import { ReactComponent as TickFill } from 'assets/icons/green-tick.svg'
import { isEmpty } from 'utils/browserHelper'
import { ReactComponent as InfoIcon } from 'assets/icons/info-icon.svg'
import { onlyNumbersRegex } from 'utils/flights/itinerary'
import { ReactComponent as GreenTick } from 'assets/icons/Green_circle_color.svg'
import {
    getUserByEmailId,
    submitPersonalDetails,
    verifyOtpForSignIn,
    saveNudge,
    sendOtpForSignIn
} from 'api/flights/results'
import { errorConfig } from './errorConfig'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'utils/globalNav/unifiedLogin'
import { resolveKeysInObjectsArrays } from 'utils/browserHelper'
import { dataLayerGA } from 'utils/dataLayerHelper.js'
const PersonalDetails = ({
    toggle,
    email,
    setEmail,
    validateEmailHandler,
    changeEmailHandler,
    isEmailValid,
    travelCheckedStatus,
    setTravelCheckedStatus,
    changeFirstNameHandler,
    isValidFirstName,
    firstName,
    validateFirstNameHandler,
    changeLastNameHandler,
    isValidLastName,
    lastName,
    validateLastNameHandler,
    gender,
    setGender,
    validateEmail,
    errorInfo,
    toggleModalAndClosePage
}) => {
    // const [otp, setOTP] = useState({
    //     value: '',
    //     error: false,
    //     verified: false
    // })
    const [countDown, setCountDown] = useState(31)
    const [retriesLeft, setRetriesLeft] = useState(4)
    const [showOtp, setShowOtp] = useState(false)
    const [showLoader, setShowLoader] = useState(false)
    const [nudge, setNudge] = useState(false)
    const [isVerificationSuccess, setIsVerificationSuccess] = useState(false)
    const [personalDetailsError, setPersonalDetailsError] = useState(false)
    const [apiError, setApiError] = useState('')
    const [loading, setLoading] = useState(false)
    const [verifyState, setVerifyState] = useState(true)
    const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()]
    const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', ''])
    const [otpValidationError, setOtpValidationError] = useState('')
    const [elementInFocus, setElemntInFocus] = useState(0)
    const stopTimerRef = useRef(false)
    const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
    const pathname = query.split('/')
    const pagePath = pathname[2]

    const checkHiFiveFlow = () => {
        const retVal =
            pathname &&
            pathname.length > 2 &&
            pathname[1] === 'ref' &&
            !isEmpty(pathname[2]) &&
            pathname[2] != 'null' &&
            pathname[2] != 'undefined'
        return retVal
    }

    const isHiFiveFlow = checkHiFiveFlow()

    useEffect(() => {
        ClevertapEvent({
            actionName: 'Profile_details_modal_opened',
            actionType: 'Button',
            page:
                pagePath === 'results'
                    ? 'SRP'
                    : isEmpty(pagePath) || isHiFiveFlow
                    ? 'HP'
                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                    ? 'Itinerary'
                    : 'Confirmation_Page',

            currentPage: pagePath
        })
    }, [])
    useEffect(() => {
        if (showOtp) {
            setCountDown(31)
            stopTimerRef.current = false
            countDownHandler(31)
            refs[0]?.current?.focus()
        }
    }, [showOtp])
    useEffect(() => {
        const otp = getOtpValue()
        if (otp.length === 6 && !apiError && !otpValidationError) {
            verifyOtpHandler()
        }
    }, [otpDigits])

    // const otpChangeHandler = e => {
    //     setPersonalDetailsError('')
    //     setApiError('')
    //     const val = e.target.value

    //     if (!onlyNumbersRegex.test(val) && !isEmpty(val)) {
    //         return
    //     }
    //     if (val.length > 6) {
    //         return
    //     }
    //     setOTP(prevState => {
    //         return {
    //             ...prevState,
    //             value: val,
    //             error: false,
    //             verified: false
    //         }
    //     })
    // }
    const getOtpValue = () => {
        const otp = otpDigits.join('')
        return otp
    }
    const otpChangeHandler = (event, index) => {
        setOtpValidationError(false)
        setApiError('')
        setPersonalDetailsError('')
        const value = event.nativeEvent.data || event.target.value
        const numberValue = Number(value)
        if (value === ' ') return
        if (value === '') {
            const otpFieldValues = [...otpDigits]
            otpFieldValues[index] = ''
            setOtpDigits(otpFieldValues)
            return
        }
        if (numberValue >= 0 && Number.isInteger(numberValue)) {
            const otpFieldValues = [...otpDigits]
            otpFieldValues[index] = value % 10
            setOtpDigits(otpFieldValues)
            setElementInFocus(index + 1)
            return
        }
    }

    const verifyOtpHandler = async () => {
        try {
            setShowLoader(true)
            const otp = getOtpValue()
            const payload = {
                type: 'EMAIL',
                value: email,
                countryCode: '',
                action: 'SIGNUP_MERGE',
                otp: otp
            }
            const response = await verifyOtpForSignIn(payload)
            const { status, data, error } = response || {}
            setTimeout(() => {
                if (status === 200) {
                    ClevertapEvent({
                        actionName: 'Email_verified_successfully',
                        actionType: 'Button',
                        page:
                            pagePath === 'results'
                                ? 'SRP'
                                : isEmpty(pagePath) || isHiFiveFlow
                                ? 'HP'
                                : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                ? 'Itinerary'
                                : 'Confirmation_Page',

                        currentPage: pagePath
                    })
                    setIsVerificationSuccess(true)
                } else {
                    const { response = { data: {} } } = error || {}
                    const { data = {} } = response
                    const { message } = data
                    const err = errorConfig[message] || errorConfig.default
                    // setOTP({ ...otp, error: err })

                    if (message === 'INVALID_OTP') {
                        setOtpValidationError(err)
                        ClevertapEvent({
                            action_name: 'invalid_otp_message',
                            page:
                                pagePath === 'results'
                                    ? 'SRP'
                                    : isEmpty(pagePath) || isHiFiveFlow
                                    ? 'HP'
                                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                    ? 'Itinerary'
                                    : 'Confirmation_Page',
                            platform: 'Desktop',
                            is_logged_in: 'Yes'
                        })
                    } else if (message === 'EMAIL_ACCOUNT_IS_ALREADY_LINKED_TO_DIFFERENT_MOBILE') {
                        ClevertapEvent({
                            action_name: 'email_exists_message',
                            page:
                                pagePath === 'results'
                                    ? 'SRP'
                                    : isEmpty(pagePath) || isHiFiveFlow
                                    ? 'HP'
                                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                    ? 'Itinerary'
                                    : 'Confirmation_Page',
                            platform: 'Desktop',
                            is_logged_in: 'Yes'
                        })
                        setApiError(err)
                    } else {
                        setApiError(err)
                    }
                }

                setShowLoader(false)
            }, 500)
        } catch (e) {
            console.log('Otp verification api error', e)
            // setOTP({ ...otp, error: errorConfig.default })
            setApiError(err)

            setShowLoader(false)
        }
    }

    const otpResendHandler = async () => {
        ClevertapEvent({
            actionName: 'resend_otp_clicked',
            platform: 'desktop',
            page:
                pagePath === 'results'
                    ? 'SRP'
                    : isEmpty(pagePath) || isHiFiveFlow
                    ? 'HP'
                    : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                    ? 'Itinerary'
                    : 'Confirmation_Page',
            is_logged_in: 'no',
            domainName: 'www.cleartrip.com'
        })
        // send otp logic
        //set retries = -1 if limit exceed
        setApiError('')
        if (countDown !== 0 || retriesLeft <= 0) {
            return
        } else {
            try {
                const payload = {
                    type: 'EMAIL',
                    value: email,
                    action: 'SIGNUP_MERGE'
                }
                const response = await sendOtpForSignIn(payload)
                const { status, data, error } = response || {}
                if (status === 202) {
                    const { action } = data || {}

                    // setOTP({
                    //     ...otp,
                    //     value: '',
                    //     error: false
                    // })
                    countDownHandler(31)
                } else {
                    const { response = { data: {} } } = error || {}
                    const { data = {} } = response
                    const { message } = data

                    const err = errorConfig[message] || errorConfig.default
                    setApiError(err)
                    if (message === 'OTP_SEND_LIMIT_EXCEEDED') {
                        setRetriesLeft(-1)
                    }
                }
            } catch (e) {
                console.log('Resend api error', e)
            }
        }
    }

    const countDownHandler = (countDown, lastCountdown = false) => {
        if (countDown === 0) {
            return
        } else {
            if (countDown === 1) {
                if (lastCountdown) {
                    setRetriesLeft(-1)
                }
            }
            // const updatedCountDown = countDown - 1
            // setCountDown(updatedCountDown)
            // setTimeout(() => countDownHandler(updatedCountDown, lastCountdown), 1000)
            if (!stopTimerRef.current) {
                const updatedCountDown = countDown - 1
                setCountDown(updatedCountDown)
                setTimeout(() => countDownHandler(updatedCountDown, lastCountdown), 1000)
            } else {
                setCountDown(31)
            }
        }
    }

    const submitDetails = async () => {
        try {
            const payload = {
                marketingSubscription: 0,
                personalData: {
                    firstName: firstName,
                    lastName: lastName,
                    gender: gender
                }
            }
            const response = await submitPersonalDetails(payload)
            const { status, data, error } = response || {}
            if (status === 200) {
                ClevertapEvent({
                    actionName: 'Profile_details_submitted',
                    actionType: 'Button',
                    page:
                        pagePath === 'results'
                            ? 'SRP'
                            : isEmpty(pagePath) || isHiFiveFlow
                            ? 'HP'
                            : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                            ? 'Itinerary'
                            : 'Confirmation_Page',

                    currentPage: pagePath,
                    send_me_offer_details_check_box: travelCheckedStatus ? 'Y' : 'N'
                })
                if (isHiFiveFlow) {
                    toggleModalAndClosePage(false)
                } else {
                    toggleModalAndClosePage()
                }
            } else {
                const { response = { data: {} } } = error || {}
                const { data = {} } = response
                const { message } = data
                const err = errorConfig[message] || errorConfig.default
                setApiError(err)
            }
        } catch (e) {
            console.log('Submit details api error', e)
            setApiError(errorConfig.default)
        }
    }

    const dalayerGA = () => {
        dataLayerGA({ section: 'Login' }, 'login_skip_clicked')
    }

    const onDone = async () => {
        dataLayerGA({ registered_gender: gender, method: 'email' }, 'sign_up')

        setLoading(true)
        let errorNudge = false
        if (isEmpty(email) && isEmpty(firstName) && isEmpty(lastName) && isEmpty(gender)) {
            errorNudge = true
        }
        const isFirstNameValid = isEmpty(firstName) ? true : validateFirstNameHandler(firstName)
        const isLastNameValid = isEmpty(lastName) ? true : validateLastNameHandler(lastName)
        setPersonalDetailsError(errorNudge)
        if (isFirstNameValid && isLastNameValid && (isVerificationSuccess || isEmpty(email))) {
            if (!errorNudge) {
                submitDetails()
            }
        } else {
            const isEmailValid = validateEmailHandler()
            if (!isEmailValid || !isFirstNameValid || !isLastNameValid) {
                ClevertapEvent({
                    actionName: 'Invalid_value_entered',
                    actionType: 'Button',
                    page:
                        pagePath === 'results'
                            ? 'SRP'
                            : isEmpty(pagePath) || isHiFiveFlow
                            ? 'HP'
                            : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                            ? 'Itinerary'
                            : 'Confirmation_Page',

                    currentPage: pagePath,
                    field_name: `${!isEmailValid ? 'email' : ''} ${!isFirstNameValid ? 'first name' : ''} ${
                        !isLastNameValid ? 'last name' : ''
                    }`,
                    form_name: 'profile_details'
                })
                setLoading(false)
                return
            }
            if (!errorNudge) {
                submitDetails()
            }
        }
        setLoading(false)
    }
    const verifyEmailDetails = async () => {
        setVerifyState(false)
        const isEmailValid = validateEmailHandler()
        if (!isEmailValid) {
            ClevertapEvent({
                actionName: 'Invalid_value_entered',
                actionType: 'Button',
                page:
                    pagePath === 'results'
                        ? 'SRP'
                        : isEmpty(pagePath) || isHiFiveFlow
                        ? 'HP'
                        : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                        ? 'Itinerary'
                        : 'Confirmation_Page',

                currentPage: pagePath,
                field_name: 'email',
                form_name: 'profile_details'
            })
            setVerifyState(true)
            return
        }
        const response = await getUserByEmailId(email)
        const { status, data } = response
        if (status === 200) {
            ClevertapEvent({
                action_name: 'email_exists_message',
                page:
                    pagePath === 'results'
                        ? 'SRP'
                        : isEmpty(pagePath) || isHiFiveFlow
                        ? 'HP'
                        : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                        ? 'Itinerary'
                        : 'Confirmation_Page',
                platform: 'Desktop',
                is_logged_in: 'Yes'
            })
            setNudge(true)
            setVerifyState(false)
        } else {
            sendOtp()

            setVerifyState(true)
        }
    }
    const sendOtp = async () => {
        setApiError('')
        const payload = {
            type: 'EMAIL',
            value: email,
            action: 'SIGNUP_MERGE'
        }
        const res = await sendOtpForSignIn(payload)
        const { status, data, error } = res || {}
        if (status === 202) {
            setShowOtp(true)
        } else {
            const { response = { data: {} } } = error || {}
            const { data = {} } = response
            const { message } = data
            const err = errorConfig[message] || errorConfig.default
            setApiError(err)
        }
    }
    function changeFirstName(e) {
        setPersonalDetailsError('')
        setApiError('')
        changeFirstNameHandler(e)
    }
    function changeLastName(e) {
        setPersonalDetailsError('')
        setApiError('')
        changeLastNameHandler(e)
    }
    const setElementInFocus = index => {
        setElemntInFocus(index)
        refs[index]?.current?.focus()
    }

    const otpCursorHandler = (event, index) => {
        if (event.keyCode === 37) {
            setElementInFocus(index - 1)
        }
        if (event.keyCode === 39) {
            setElementInFocus(index + 1)
        }
        if (event.keyCode === 8) {
            if (event.target.value === '') {
                const otpFieldValues = [...otpDigits]
                const indexToRemove = index - 1
                if (indexToRemove < 0) {
                    return
                }
                otpFieldValues[indexToRemove] = ''
                setOtpDigits(otpFieldValues)
                setElementInFocus(indexToRemove)
            } else {
                const otpFieldValues = [...otpDigits]
                otpFieldValues[index] = ''
                setOtpDigits(otpFieldValues)
            }
        }
    }
    const otpBlock = [1, 2, 3, 4, 5, 6].map((element, index) => {
        return (
            <OtpBox
                disabled={isVerificationSuccess}
                key={index}
                onKeyDown={e => otpCursorHandler(e, index)}
                onChange={e => otpChangeHandler(e, index)}
                onMouseDownCapture={() => {
                    setElementInFocus(index)
                }}
                ref={refs[index]}
                value={otpDigits[index]}
                style={{
                    margin: `0px 4px 4px 0px`,
                    border: otpValidationError
                        ? ' solid 1px #ff3c2b'
                        : refs[index]?.current === document.activeElement
                        ? 'solid 1px #36c'
                        : 'solid 1px #e6e6e6',
                    width: '36px',
                    height: '36px'
                }}
            />
        )
    })
    return (
        <div
            className="bg-white br-4 br-4 o-hidden d-flex flex-column"
            style={{
                width: '400px',
                // minHeight: '80vh',
                maxHeight: 'calc(100vh - 80px)'
            }}
        >
            <div
                className={`px-8 d-flex flex-1 flex-column`}
                // onKeyDown={e => {
                //     if (e.key === 'Enter') {
                //         onDone()
                //     }
                // }}
            >
                {/* <ModalHeader title={} toggle={toggle} showCloseButton={false} /> */}
                <div className="pt-6 pb-6">
                    <div className="flex flex-between flex-middle">
                        <span className="fs-7 fw-600 c-neutral-900">{'Almost there..'}</span>
                    </div>
                </div>
                <Spacer className="mb-1" />

                <div className="flex flex-1 flex-column">
                    <div
                        className="flex flex-1 flex-column oy-scroll mb-7"
                        style={{ maxHeight: 'calc(100vh - 250px)' }}
                    >
                        <OfflineToast page="proceed" />
                        {personalDetailsError && (
                            <>
                                <div className="py-2 px-2 h-8 flex flex-middle bg-error-600 c-white fs-2 br-4 ">
                                    <InfoIcon className="c-white" height={16} width={16} />
                                    <span data-testid="signinError" className={errorInfo}>
                                        {'Please fill all the empty fields or select skip'}
                                    </span>
                                </div>
                                <Spacer className="pt-4" />
                            </>
                        )}
                        {apiError && (
                            <>
                                <div className="py-2 px-2 h-8 flex flex-middle bg-error-600 c-white fs-2 br-4 ">
                                    <InfoIcon className="c-white" height={16} width={16} />
                                    <span data-testid="signinError" className={errorInfo}>
                                        {apiError}
                                    </span>
                                </div>
                                <Spacer className="pt-4" />
                            </>
                        )}

                        <div className="d-flex flex-column">
                            <div className="c-neutral-700 fs-3 mb-3">
                                Email address<span style={{ color: 'red' }}> *</span>
                            </div>

                            <div className="d-flex flex-column">
                                <div className="flex-1 d-flex">
                                    <div className="flex-1">
                                        <div className="p-relative">
                                            <Field
                                                type="email"
                                                placeholder="Email address"
                                                className=" lh-title pr-14"
                                                style={{
                                                    borderTopRightRadius:
                                                        showOtp && !isVerificationSuccess ? '0px' : '',
                                                    borderBottomRightRadius:
                                                        showOtp && !isVerificationSuccess ? '0px' : '',
                                                    borderRight: showOtp && !isVerificationSuccess ? '0px' : ''
                                                }}
                                                onChange={e => {
                                                    changeEmailHandler(e)
                                                    setPersonalDetailsError('')
                                                    setApiError('')
                                                    setNudge(false)
                                                    setVerifyState(true)
                                                }}
                                                disabled={showOtp || isVerificationSuccess}
                                                hasError={
                                                    !showOtp &&
                                                    ((!isEmailValid && !isEmpty(email)) ||
                                                        (!isEmpty(email) && validateEmail(email) && nudge))
                                                }
                                                value={email}
                                            />
                                            {!showOtp && !isVerificationSuccess && (
                                                <span
                                                    className={`fs-3 ${
                                                        isEmpty(email) || !verifyState
                                                            ? 'c-neutral-400'
                                                            : 'c-secondary-500 c-pointer hover:td-underline'
                                                    } p-absolute h-9 flex flex-middle r-2 fw-500 t-0`}
                                                    onClick={() => {
                                                        setPersonalDetailsError('')
                                                        setApiError('')
                                                        verifyEmailDetails()
                                                    }}
                                                    // style={{
                                                    //     borderTopLeftRadius: '0px',
                                                    //     borderBottomLeftRadius: '0px',
                                                    //     borderLeft: '0px',
                                                    //     backgroundColor: showOtp || isVerificationSuccess ? '#f7f7f7' : '',
                                                    //     border: showOtp || isVerificationSuccess ? 'solid 1px transparent' : ''
                                                    // }}
                                                >
                                                    Verify
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    {showOtp && !isVerificationSuccess && (
                                        <div
                                            className="c-pointer pr-2 fw-500 fs-3 c-secondary-500 r-4 h-9 t-0 flex flex-middle hover:td-underline bc-neutral-100 bw-1 box-border bs-solid br-4"
                                            onClick={() => {
                                                stopTimerRef.current = true
                                                setPersonalDetailsError('')
                                                setApiError('')
                                                setShowOtp(false)
                                                setNudge(false)
                                                setOtpValidationError('')
                                                setOtpDigits(['', '', '', '', '', ''])
                                            }}
                                            style={{
                                                borderTopLeftRadius: '0px',
                                                borderBottomLeftRadius: '0px',
                                                borderLeft: '0px',
                                                backgroundColor: showOtp || isVerificationSuccess ? '#f7f7f7' : '',
                                                border: showOtp || isVerificationSuccess ? 'solid 1px transparent' : ''
                                            }}
                                        >
                                            Change
                                        </div>
                                    )}
                                </div>
                                {!isEmailValid && !isEmpty(email) && !showOtp && (
                                    <div data-testid="invalidEmail" className="c-error-500 fs-2 mt-1">
                                        {'Please enter a valid email address'}
                                    </div>
                                )}
                                {!isEmpty(email) && validateEmail(email) && nudge && !showOtp && (
                                    <div data-testid="invalidEmail" className="c-error-500 fs-2 mt-1">
                                        {'An account with this email already exists'}
                                    </div>
                                )}
                            </div>

                            {!isEmpty(email) && validateEmail(email) && nudge && !showOtp && (
                                <div className="mt-3 bg-neutral-0 px-3 py-2 br-4">
                                    <span className="fs-2 c-neutral-700">Does this email belong to you?</span>
                                    <span
                                        className="fs-2 c-blue c-pointer"
                                        onClick={() => {
                                            sendOtp()
                                        }}
                                    >
                                        {' '}
                                        Yes, this is mine{' '}
                                    </span>
                                </div>
                            )}
                            {isVerificationSuccess && (
                                <div className="d-flex flex-row flex-middle flex-between mt-1">
                                    <div className="d-flex flex-middle">
                                        <GreenTick />
                                        <div className="fs-2 fw-500 c-success-300 ml-1" style={{ color: '#328313' }}>
                                        Email linked successfully with this account. 
                                        </div>
                                    </div>
                                </div>
                            )}

                            {showOtp && !isVerificationSuccess && (
                                <>
                                    {/* <otpBox
                                        placeholder="Enter 6-digit OTP"
                                        value={otp.value}
                                        onChange={otpChangeHandler}
                                        ctaText="Verify"
                                        ctaAction={verifyOtpHandler}
                                        hasError={otp.error}
                                    /> */}
                                    <div className="d-flex mt-4 mb-1 flex-middle" style={{ height: '36px' }}>
                                        {otpBlock}
                                        {showLoader && (
                                            <div style={{ height: '20px', width: '20px' }} className="loader"></div>
                                        )}
                                    </div>
                                    {otpValidationError && (
                                        <div className="fs-2 mt-1 mb-1 c-error-500">Please enter a valid OTP.</div>
                                    )}
                                    {
                                        <div className="fs-2 pt-1 c-neutral-600">
                                            OTP has been sent to your email address.
                                            <span
                                                onClick={otpResendHandler}
                                                className={`fs-2 fw-500 ml-1 ${
                                                    retriesLeft === -1
                                                        ? 'c-neutral-200'
                                                        : countDown !== 0
                                                        ? `c-neutral-200`
                                                        : 'c-blue c-pointer'
                                                }`}
                                            >
                                                {retriesLeft === -1
                                                    ? 'Resend'
                                                    : countDown !== 0
                                                    ? `Resend (${countDown}s)`
                                                    : 'Resend'}
                                            </span>
                                        </div>
                                    }
                                </>
                            )}
                        </div>

                        <Spacer className="mb-7" />

                        <div className="d-flex flex-column mb-7">
                            <div className="c-neutral-700 fs-3 mb-2">Your name</div>
                            <Field
                                placeholder="First Name"
                                className=" lh-title "
                                onChange={changeFirstName}
                                value={firstName}
                                hasError={!isValidFirstName && firstName.length > 0}
                            />
                            {!isValidFirstName && firstName.length > 0 && (
                                <div data-testid="firstNameFieldInvalid" className="c-error-500 fs-2 mt-1">
                                    {'Please enter a valid first name'}
                                </div>
                            )}
                            <Spacer className="mb-4" />
                            <Field
                                type="email"
                                placeholder="Last Name"
                                className=" lh-title"
                                onChange={changeLastName}
                                value={lastName}
                                hasError={!isValidLastName && lastName.length > 0}
                            />

                            {!isValidLastName && lastName.length > 0 && (
                                <div data-testid="lastNameFieldInvalid" className="c-error-500 fs-2 mt-1">
                                    {'Please enter a valid last name'}
                                </div>
                            )}
                        </div>

                        <div className="d-flex flex-column mb-4">
                            <div className="c-neutral-700 fs-3 mb-2">Gender</div>
                            <div className="d-flex flex-row">
                                <div className="mr-9">
                                    <Radio
                                        name="gender"
                                        onClick={() => {
                                            setPersonalDetailsError('')
                                            setApiError('')
                                            setGender('MALE')
                                        }}
                                        // onChange={() => genderClickHandler('FEMALE')}
                                        checked={gender === 'MALE'}
                                    >
                                        <span className="ml-2 fs-3 c-neutral-700">Male</span>
                                    </Radio>
                                </div>
                                <div className="mr-9">
                                    <Radio
                                        name="gender"
                                        onClick={() => {
                                            setPersonalDetailsError('')
                                            setApiError('')
                                            setGender('FEMALE')
                                        }}
                                        // onChange={() => genderClickHandler('FEMALE')}
                                        checked={gender === 'FEMALE'}
                                    >
                                        <span className="ml-2 fs-3 c-neutral-700">Female</span>
                                    </Radio>
                                </div>
                                <div className="mr-9">
                                    <Radio
                                        name="gender"
                                        onClick={() => {
                                            setPersonalDetailsError('')
                                            setApiError('')
                                            setGender('OTHER')
                                        }}
                                        // onChange={() => genderClickHandler('FEMALE')}
                                        checked={gender === 'OTHER'}
                                    >
                                        <span className="ml-2 fs-3 c-neutral-700">Other</span>
                                    </Radio>
                                </div>
                            </div>
                        </div>

                        {/* <div className="flex flex-middle mb-4">
                            <div>
                                <Checkbox
                                    checked={travelCheckedStatus}
                                    onClick={() => setTravelCheckedStatus(!travelCheckedStatus)}
                                />
                            </div>
                            <div className="fs-2 c-neutral-700 ml-2 " style={{ marginTop: '-1px' }}>
                                Send me offers and news by email and SMS.
                            </div>
                        </div> */}
                    </div>

                    <div className="flex flex-column ">
                        <div className="mb-5">
                            <Button
                                size="md"
                                type="secondary"
                                full
                                onClick={() => {
                                    onDone()
                                }}
                                busy={loading}
                                disabled={!isVerificationSuccess}
                                // onClick={() => goBackAnimation(USER_PROFILE_PAGE_CONTANTS.SIGNIN_PAGE)}
                            >
                                <span className="fs-3 fw-550">{langTranslate('Done')}</span>
                            </Button>
                            <div className="ta-center fs-3 fw-600 c-blue c-pointer mt-4" onClick={() => {
                                toggle()
                            }}>
                            Not now
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PersonalDetails
